import { createContext } from 'react';
// const ThemeContext = createContext();
const ThemeContext = createContext(null);
export default ThemeContext;
